module.exports = __webpack_public_path__ + "img/232.13a13e78.jpg";